import React, { useState } from "react";

const questions = require("../contents/questions.json");
function QuestionPage(props) {
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [showResult, setShowResult] = useState(false);
    const quiz = questions[(props?.question || 1) - 1];
    const totalQuestions = questions.length;


    const handleAnswerClick = (index) => {
        if (selectedAnswers.includes(index)) {
            setSelectedAnswers(selectedAnswers.filter((answer) => answer !== index));
        } else {
            setSelectedAnswers([...selectedAnswers, index]);
        }
    };

    const handleSubmit = () => {
        props.onSubmit(selectedAnswers);
    };

    const isCorrect =
        selectedAnswers.length === quiz.correctAnswers.length && selectedAnswers.every((answer) => quiz.correctAnswers.includes(answer));

    const backgroundImage = quiz.image
        ? `url('/image/${quiz.image}')`
        : "url('https://images.unsplash.com/photo-1736077722346-31ba59414728?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')";

    return (
        <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50">
            {/* Background Image with Fade */}
            <div className="absolute top-0 left-0 w-full h-1/3 bg-cover bg-center" style={{ backgroundImage }}>
                <div className="w-full h-full bg-gradient-to-b from-transparent to-gray-50"></div>
            </div>

            {/* Content Container */}
            <div className="relative flex flex-col items-center justify-center max-w-screen-lg mx-auto pt-8">
                <h2 className="text-2xl font-semibold text-gray-700 mb-1 mt-8 text-center">Question {props.question}</h2>
                <h1 className="text-2xl font-bold text-blue-700 mb-2 text-center">{quiz.question}</h1>
                <div className="text-center w-full">
                    <div className="flex flex-col items-center w-full">
                        {quiz.answers.length > 0 ? (
                            quiz.answers.map((answer, index) => (
                                <div
                                    key={index}
                                    className={`mb-2 px-4 py-2 my-1 w-4/5 text-black rounded text-left cursor-pointer shadow hover:shadow-lg ${
                                        selectedAnswers.includes(index) ? "bg-gray-200" : !showResult ? "bg-gray-50" : ""
                                    } ${showResult && quiz.correctAnswers.includes(index) ? "bg-green-300" : ""} ${
                                        showResult && !quiz.correctAnswers.includes(index) && selectedAnswers.includes(index) ? "bg-red-300" : ""
                                    }`}
                                    onClick={() => !showResult && handleAnswerClick(index)}
                                >
                                    {answer}
                                </div>
                            ))
                        ) : (
                            <textarea
                                className="mb-2 px-4 py-2 my-1 w-4/5 text-black rounded text-left shadow hover:shadow-lg bg-gray-50"
                                rows="4"
                                placeholder="Type your answer here..."
                                onChange={(e) => setSelectedAnswers([e.target.value])}
                            />
                        )}
                    </div>
                    <button
                        className="mt-4 px-4 py-2 w-4/5 bg-blue-500 text-white rounded-full"
                        onClick={handleSubmit}
                    >
                        {props.question == totalQuestions ? "Finish" : "Next Question"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default QuestionPage;
